export default /^(min-|max-)?(block|inline)-(size)$/i;
